import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../../baseQuery/basePlatformQuery';
import { EConsent, EConsentResponse, EConsentVersion } from './types';

export const eConsentPlatformApi = createApi({
    reducerPath: 'eConsentPharmaNavigatorApi',
    baseQuery,
    tagTypes: ['eConsent', 'eConsentVersions', 'signingHistory'],
    endpoints: (builder) => ({
        getEConsentText: builder.query<EConsent, void>({
            query: () => '/api/v1/platform/e-consent',
            providesTags: ['eConsent'],
        }),
        getEConsentVersions: builder.query<EConsentResponse<EConsentVersion>, string>({
            query: (query) => `/api/v1/platform/e-consent/versions?${query}`,
            providesTags: ['eConsentVersions'],
        }),
        getEConsentPDF: builder.query<{ url: string; filename: string }, string>({
            query: (documentVersion) => ({
                url: `/api/v1/platform/e-consent/download/${documentVersion}`,
                responseHandler: async (response) => {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);

                    const contentDisposition = response.headers.get('Content-Disposition');
                    const match = contentDisposition?.match(/filename="?([^";]+)"?/);
                    const filename = match ? match[1] : `PharmaNavigator-EConsent-${documentVersion}.pdf`;

                    return { url, filename };
                },
            }),
        }),
        updateEConsentText: builder.mutation<{ content: string }, { content: string }>({
            query: ({ content }: { content: string }) => ({
                url: '/api/v1/platform/e-consent',
                method: 'POST',
                body: { content },
            }),
            invalidatesTags: ['eConsent', 'eConsentVersions'],
        }),
    }),
});

export const {
    useGetEConsentTextQuery,
    useUpdateEConsentTextMutation,
    useLazyGetEConsentPDFQuery,
    useGetEConsentVersionsQuery,
} = eConsentPlatformApi;
